import 'react-app-polyfill/ie11';
//import 'promise-polyfill/src/polyfill';
import 'react-app-polyfill/stable';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { createBrowserHistory } from "history";
import { Router, Switch } from "react-router-dom";
import { publicViews, privateViews, adminViews, bankAminViews, helpDeskAdminViews,biometricAdminViews} from 'routes/Routes';
import PublicRoute from 'routes/PublicRoute';
import PrivateRoute from './routes/PrivateRoute';
import AdminRoute from './routes/AdminRoute';
import BankAdminRoute from './routes/BankAdminRoute';
import HelpDeskRoute from './routes/HelpDeskRoute';
import BiometricRoute from './routes/BiometricRoute';
import _branding from 'modules/branding';
import { LanguageProvider } from 'modules/LanguageContext';

import 'assets/css/index.css';


const hist = createBrowserHistory();

// Sprint 2.4 (Branding Foundation): fires once at startup, non-blocking — applies any admin-configured
// branding overrides (primary/secondary color) as soon as they arrive. Never delays first render.
_branding.applyBranding();

ReactDOM.render(
  // Stage 3.9 (Tasks 5/6): wraps the whole app (not just PublicLayout/PrivateLayout) so a candidate's
  // language/display-mode choice persists across the Public -> Private (login) transition instead of
  // resetting. Fetches Language config once (LanguageContext.js), degrades gracefully to today's actual
  // behavior (bilingual en+mr) if the fetch fails — never blocks first render.
  <LanguageProvider>
  <Router history={hist}>
    <Switch>

      {publicViews.map((prop, key) => {
        return <PublicRoute exact path={prop.path} component={prop.component} key={key} />;
      })}

      {privateViews.map((prop, key) => {
        return <PrivateRoute exact path={prop.path} component={prop.component} key={key} role={prop.roles} menuId={prop.menuId} />;
      })}

      {adminViews.map((prop, key) => {        
        return <AdminRoute exact path={prop.path} component={prop.component} key={key} role={prop.roles} menuId={prop.menuId} />;
      })}

      {bankAminViews.map((prop, key) => {        
        return <BankAdminRoute exact path={prop.path} component={prop.component} key={key} role={prop.roles} menuId={prop.menuId} />;
      })}

      {helpDeskAdminViews.map((prop, key) => {        
        return <HelpDeskRoute exact path={prop.path} component={prop.component} key={key} role={prop.roles} menuId={prop.menuId} />;
      })}

      {biometricAdminViews.map((prop, key) => {        
        return <BiometricRoute exact path={prop.path} component={prop.component} key={key} role={prop.roles} menuId={prop.menuId} />;
      })}


    </Switch>
  </Router>
  </LanguageProvider>
  , document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
